SP.CollectionSortBy = Garnish.Base.extend({
    $el: null,
    $sortSelector: null,
    $sortTriggerBtn: null,
    $sortMenu: null,
    $sortLabel: null,
    queryParams: {},

    init(el) {
        this.$el = $(el)
        this.$sortSelector = $('.sort-selector')
        this.$sortMenu = this.$el.find('.sort-by-menu')
        this.$sortTriggerBtn = this.$el.find('.sort-trigger')
        this.$sortLabel = this.$el.find('.sort-label')

        this.initParams()

        this.addListener(this.$sortTriggerBtn, 'click', this.showSortMenu)
        this.addListener(this.$sortSelector, 'click', this.onChangeSort)
    },

    initParams() {
        let self = this

        this.defaultSort = this.$el.data('default-sortby')

        if (location.search.length) {
            let aKeyValue
            let aCouples = location.search.substr(1).split('&')
            for (let i = 0; i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=')
                if (aKeyValue.length > 1) {
                    self.queryParams[
                        decodeURIComponent(aKeyValue[0])
                        ] = decodeURIComponent(aKeyValue[1])
                }
            }
        }

        if (this.queryParams.sort_by) {
            let label = $('li[data-value="' + this.queryParams.sort_by + '"]').data('label')
            this.$sortLabel.html(label)
        } else {
            let label = this.getSortLabel()
            this.$sortLabel.html(label)
        }
    },

    getSortLabel() {
        let el = this.$sortMenu.find('.selected.sort-selector')

        if (el.length > 0) {
            return el.data('label')
        }

        return null
    },

    showSortMenu() {
        this.$sortMenu.toggleClass('active')
        this.$sortTriggerBtn.toggleClass('active')

        if (this.$sortMenu.hasClass('active')) {
            this.addListener($('body'), 'click', this.closeSortMenu)
        } else {
            this.removeListener($('body'), 'click')
        }
    },

    onChangeSort(ev) {
        ev.preventDefault()
        let value = $(ev.currentTarget).data('value')

        this.queryParams.sort_by = this.getSortValue(value)

        if (this.queryParams.page) {
            delete this.queryParams.page;
        }
        window.location.search = decodeURIComponent($.param(this.queryParams))
    },

    getSortValue: function (value) {
        return value || this.defaultSort
    },

    closeSortMenu(ev) {
        if (!this.$el.is(ev.target) && this.$el.has(ev.target).length === 0 && this.$sortMenu.hasClass('active')) {
            this.$sortMenu.removeClass('active')
            this.removeListener($('body'), 'click')
            this.$sortTriggerBtn.removeClass('active')
        }
    }
})